var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalysisChart',{attrs:{"endpoint":"web/get-mortality-analysis","data-key":"mortality","standard-key":"standard_mortality","series-label":"Mortality","standard-label":"Standard Mortality","yaxis-title":"Mortality (%)"}})}
var staticRenderFns = []

export { render, staticRenderFns }